<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">الصورة الرئيسية في الموقع</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "HomeImageForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                 
              <!-- to insert image  -->
              <div class="col-6 my-3 " >
                <label for="validation03"><span class="validation-required">*</span> Desktop</label>
                <br>
                <small class="danger dimensions">Dimensions  1920 * 759</small>
                <br>
                <img  src="{{ DesktopimageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
               <input type="file" formControlName="Desktop" accept="image/*" #file id="getLogoDesktop"
                style="display: none" (change)="getLogoUrlDesktop($event)" />
            <button type="button" onclick="document.getElementById('getLogoDesktop').click()"
                class="btn   d-block"  style="width: 60%;">
                ارفاق صورة
            </button>    
                        </div>

                        <div class="col-6 my-3 " >
                            <label for="validation03"><span class="validation-required">*</span> Ipad</label>
                            <br>
                            <small class="danger dimensions">Dimensions  2134 * 1601</small>
                            <br>
                            <img  src="{{ IpadimageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                           <input type="file" formControlName="Ipad" accept="image/*" #file id="getLogoIpad"
                            style="display: none" (change)="getLogoUrlIpad($event)" />
                        <button type="button" onclick="document.getElementById('getLogoIpad').click()"
                            class="btn   d-block"  style="width: 60%;">
                            ارفاق صورة
                        </button>    
                                    </div>

                                    <div class="col-6 my-3 " >
                                        <label for="validation03"><span class="validation-required">*</span> Ipad Portrait</label>
                                        <br>
                                        <small class="danger dimensions">Dimensions  1600 * 2134</small>
                                        <br>
                                        
                                        <img  src="{{ IpadportraitimageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                                       <input type="file" formControlName="Ipadportrait" accept="image/*" #file id="getLogoIpadportrait"
                                        style="display: none" (change)="getLogoUrlIpadportrait($event)" />
                                    <button type="button" onclick="document.getElementById('getLogoIpadportrait').click()"
                                        class="btn   d-block"  style="width: 60%;">
                                        ارفاق صورة
                                    </button>    
                                                </div>


                                                <div class="col-6 my-3 " >
                                                    <label for="validation03"><span class="validation-required">*</span> Mobile</label>
                                                    <br>
                                                    <small class="danger dimensions">Dimensions  430 * 896</small>
                                                    <br>
                                                    <img  src="{{ MobileimageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                                                   <input type="file" formControlName="Mobile" accept="image/*" #file id="getLogoMobile"
                                                    style="display: none" (change)="getLogoUrlMobile($event)" />
                                                <button type="button" onclick="document.getElementById('getLogoMobile').click()"
                                                    class="btn   d-block"  style="width: 60%;">
                                                    ارفاق صورة
                                                </button>    
                                                            </div>
                
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn  pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

